import React, { Fragment } from 'react';
import { Grid, Header, Form } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import {
  LoadingPage,
  NotificationDialog,
  DatePickerCustomButton,
} from 'Components';
import { DatePickerField } from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { ManageProcessOrderEnum } from 'Common/FieldEnum';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';

import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import ReactTable from 'Common/ReactTableWrapper';
import { SignalRCenterProgress } from 'Components/signalRCenterProgress/container';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';

const ManageProcessOrderComponent = props => {
  const {
    manageOrderListData,
    onChangeOfFromDT,
    fromDateMax,
    onChangeOfToDT,
    toDateMin,
    columns,
    showCloseModel,
    reactTableRef,
    showDeleteModel,
    handleDeleteDialog,
    loading,
    printLoading,
    handleCloseDialog,
    closing,
    showDeleteConfirm,
    closeDeleteOrderConfirm,
    showCloseConfirm,
    closeOrderConfirm,
    showProcessModel,
    showProcessConfirm,
    handleProcessDialog,
    processOrderConfirm,
    gridPreferenceSubmitting,
    gridPreferenceLoading,
    history,
    processLoading,
    processId,
    selectedOrders,
    showConsolidateCloseOrderModal,
    showConsolidateConfirm,
    handleConsolidate,
    closeConsolidateOrderConfirm,
    orderTypesLoading,
    resetPageOnDataChange,
    expanded,
    setExpandedState,
  } = props;

  let message =
    'Please only select open orders to delete. Processed orders cannot be deleted.';
  if (
    showCloseConfirm ||
    showProcessConfirm ||
    showConsolidateCloseOrderModal
  ) {
    message =
      'Please only select Open orders to Process. Closed orders can not be processed.';
  }

  let deleteQuestion =
    'Are you sure you would like to permanently delete all checked orders?';
  let processQuestion =
    'Are you sure you would like to process all checked orders?';

  let closeQuestion =
    'This will finalize the order(s) for receiving without creating a purchase order. Are you sure you would like to close all checked orders?';
  let consolidateQuestion =
    'Are you sure you would like to consolidate all checked orders?';
  if (selectedOrders && selectedOrders.length === 1 && selectedOrders[0]) {
    deleteQuestion = `Are you sure you would like to permanently delete order# ${selectedOrders[0]} ?`;
    processQuestion = `Are you sure you would like to Process order# ${selectedOrders[0]} ?`;
    closeQuestion = `This will finalize the order(s) for receiving without creating a purchase order. 
    Are you sure you would like to close order# ${selectedOrders[0]} ?`;
    consolidateQuestion = `Are you sure you would like to consolidate order# ${selectedOrders[0]}`;
  }

  let question = showDeleteModel
    ? deleteQuestion
    : showProcessModel
    ? processQuestion
    : showConsolidateConfirm
    ? consolidateQuestion
    : closeQuestion;
  return closing || processLoading || printLoading || orderTypesLoading ? (
    <LoadingPage />
  ) : (
    <Fragment>
      <Form>
        <SignalRCenterProgress processId={processId} history={history} />
        <Grid className="grid-spacing">
          <Grid.Row columns={2}>
            <Grid.Column>
              <div style={{ paddingTop: 25 }}>
                <Header as="h4">Delivery Date Range</Header>
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={4}>
            <Grid.Column>
              <Field
                component={DatePickerField}
                customInput={<DatePickerCustomButton />}
                label={'From:'}
                dateFormat={DATE_FORMAT_FOR_UI}
                name={ManageProcessOrderEnum.BeginDT}
                onChange={onChangeOfFromDT}
                maxDate={fromDateMax}
                type={'text'}
                dropdownMode="select"
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                component={DatePickerField}
                customInput={<DatePickerCustomButton />}
                label={'To:'}
                dateFormat={DATE_FORMAT_FOR_UI}
                name={ManageProcessOrderEnum.EndDT}
                type={'text'}
                onChange={onChangeOfToDT}
                minDate={toDateMin}
                dropdownMode="select"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid>
          <Grid.Row columns={1} className={'remove-spacing'}>
            <Grid.Column>
              <ReactTable
                showFiltersPlaceholderText
                reactTableRef={reactTableRef}
                showPageSizeOptions={true}
                minRows={0}
                data={manageOrderListData}
                noDatatext={loading ? '' : 'No Orders found'}
                resizable={false}
                className="-striped -highlight modalGrid"
                columns={columns}
                loading={
                  loading || gridPreferenceLoading || gridPreferenceSubmitting
                }
                draggableColumns={true}
                showHideColumn={true}
                menu={'hasCogs'}
                saveState={{
                  tableName: TableNamesEnum.MANAGE_PROCESS_ORDER_ITEM_TABLE,
                }}
                resetPageOnDataChange={resetPageOnDataChange}
                hasSelectAllColumn={true}
                hasExpanderColumn={true}
                gridName={GridEnum.INV_ManageProcessOrder_View}
                onExpandedChange={(newExpanded, index, event) => {
                  setExpandedState(newExpanded);
                }}
                expanded={expanded}
                defaultSorted={[
                  {
                    id: ManageProcessOrderEnum.DeliveryDate,
                    desc: true,
                  },
                ]}
                SubComponent={({
                  original: { IsConsolidatedOrder, ConsolidateOrders },
                }) => {
                  if (IsConsolidatedOrder) {
                    return (
                      <div style={{ padding: 10 }}>
                        <ReactTable
                          filterable
                          showFiltersPlaceholderText
                          defaultPageSize={ConsolidateOrders.length}
                          minRows={0}
                          showPageSizeOptions={false}
                          defaultFilterMethod={(filter, row) =>
                            String(row[ManageProcessOrderEnum.Id]) ===
                            filter.value
                          }
                          className="-striped -highlight modalGrid no-hover"
                          data={ConsolidateOrders}
                          resizable={false}
                          sortable={false}
                          showPagination={false}
                          menu={false}
                          columns={[
                            {
                              Header: 'Order #',
                              accessor: ManageProcessOrderEnum.Id,
                              sortable: true,
                              filterable: false,
                              className: 'right-align',
                            },
                            {
                              Header: 'Site Id/Site',
                              accessor: row => {
                                return `${row[ManageProcessOrderEnum.SiteId]} ${
                                  row[ManageProcessOrderEnum.SiteName]
                                }`;
                              },
                              id: `${ManageProcessOrderEnum.SiteId}_${ManageProcessOrderEnum.SiteName}`,
                              sortable: true,
                              filterable: false,
                              minWidth: 150,
                            },
                            {
                              Header: 'Order Date',
                              accessor: ManageProcessOrderEnum.OrderDate,
                              sortable: true,
                              filterable: false,
                            },
                            {
                              Header: 'Delivery Date',
                              accessor: ManageProcessOrderEnum.DeliveryDate,
                              sortable: true,
                              filterable: false,
                            },
                            {
                              Header: 'Status',
                              accessor: ManageProcessOrderEnum.Status,
                              sortable: true,
                              filterable: false,
                            },
                            {
                              Header: 'Comments',
                              accessor: ManageProcessOrderEnum.Comments,
                              sortable: true,
                              filterable: false,
                            },
                          ]}
                        />
                      </div>
                    );
                  }
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <YesNoDialog
          showDialog={
            showDeleteModel ||
            showProcessModel ||
            showCloseModel ||
            showConsolidateConfirm
          }
          title={
            showDeleteModel
              ? 'Delete Order '
              : showProcessModel
              ? 'Process Order'
              : showConsolidateConfirm
              ? 'Consolidate Order'
              : 'Close Order'
          }
          question={question}
          yesCallback={() => {
            showDeleteModel
              ? handleDeleteDialog(true)
              : showProcessModel
              ? handleProcessDialog(true)
              : showConsolidateConfirm
              ? handleConsolidate(true)
              : handleCloseDialog(true);
          }}
          noCallback={() => {
            showDeleteModel
              ? handleDeleteDialog(false)
              : showProcessModel
              ? handleProcessDialog(false)
              : showConsolidateConfirm
              ? handleConsolidate(false)
              : handleCloseDialog(false);
          }}
        />
        <NotificationDialog
          title={'Manage Orders'}
          showDialog={
            showDeleteConfirm ||
            showCloseConfirm ||
            showProcessConfirm ||
            showConsolidateCloseOrderModal
          }
          message={message}
          onOkClick={
            showDeleteConfirm
              ? closeDeleteOrderConfirm
              : showProcessConfirm
              ? processOrderConfirm
              : showConsolidateCloseOrderModal
              ? closeConsolidateOrderConfirm
              : closeOrderConfirm
          }
        />
      </Form>
    </Fragment>
  );
};

ManageProcessOrderComponent.propTypes = {
  manageOrderListData: PropTypes.array.isRequired,
  onChangeOfFromDT: PropTypes.func,
  fromDateMax: PropTypes.object,
  fromDateMin: PropTypes.object,
  onChangeOfToDT: PropTypes.func,
  toDateMin: PropTypes.object,
  setSelectedSite: PropTypes.func,
  setShowStatusOption: PropTypes.func,
  clearFilters: PropTypes.func,
  setPrintOption: PropTypes.func,
  printTransactionGrid: PropTypes.func,
  columns: PropTypes.array.isRequired,
  showCloseModel: PropTypes.bool,
  reactTableRef: PropTypes.object,
  showDeleteModel: PropTypes.bool,
  handleDeleteDialog: PropTypes.func,
  loading: PropTypes.bool,
  printLoading: PropTypes.bool,
  handleCloseDialog: PropTypes.func,
  closing: PropTypes.bool,
  showDeleteConfirm: PropTypes.bool,
  closeDeleteOrderConfirm: PropTypes.func,
  showCloseConfirm: PropTypes.bool,
  closeOrderConfirm: PropTypes.func,
  viewStatusOptionsValue: PropTypes.oneOf(['All', 'Open', 'Closed']),
  printOptionsValue: PropTypes.oneOf(['ItemCode', 'Description']),
  showProcessModel: PropTypes.bool,
  showProcessConfirm: PropTypes.bool,
  handleProcessDialog: PropTypes.func,
  processOrderConfirm: PropTypes.func,
  savePreference: PropTypes.func,
  gridPreferenceSubmitting: PropTypes.bool,
  gridPreferenceLoading: PropTypes.bool,
  history: PropTypes.object,
  processLoading: PropTypes.bool,
  processId: PropTypes.string,
  selectedOrders: PropTypes.array.isRequired,
  showConsolidateCloseOrderModal: PropTypes.bool,
  showConsolidateConfirm: PropTypes.bool,
  handleConsolidate: PropTypes.func,
  closeConsolidateOrderConfirm: PropTypes.func,
  orderTypesLoading: PropTypes.bool,
  orderTypesData: PropTypes.array.isRequired,
  setOrderTypeDetails: PropTypes.func,
  handleCollapsePanelClick: PropTypes.func,
  activeIndexes: PropTypes.array.isRequired,
  resetPageOnDataChange: PropTypes.bool,
};

export default ManageProcessOrderComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/components/manageProcessOrderList/ManageProcessOrder.js